import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import type {
  DistrictCreateInput,
  DistrictUpdateInput,
} from "@/modules/geo/domain/contracts";
import { isDevMode } from "@/shared/lib/config";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { Button } from "@devhop/ui";
import { useNavigate } from "@tanstack/react-router";
import { ArrowLeftIcon, HelpCircleIcon } from "lucide-react";
import { useCreateDistrict, useProvincesQuery } from "../api/queries";
import { DistrictFormTour, useDistrictFormTour } from "../tour";
import { DistrictForm } from "../ui/DistrictForm";

export function DistrictCreatePage() {
  const nav = useNavigate({ from: "/app/geo/districts/new" });
  const provincesQuery = useProvincesQuery({ limit: 500, offset: 0 });
  const provinces = provincesQuery.data?.data ?? [];
  const createDistrict = useCreateDistrict();
  const { run, handleJoyrideCallback, startTour } = useDistrictFormTour();

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ເມືອງ", to: "/app/geo/districts" },
            { label: "ສ້າງໃໝ່" },
          ]}
        />
      </Header>
      <Main>
        <div className="flex flex-wrap items-center justify-between space-y-2">
          <div>
            <h2 className="flex items-center font-bold text-2xl tracking-tight">
              ສ້າງເມືອງ{" "}
              <Button
                variant="ghost"
                size="icon"
                onClick={startTour}
                className="ml-2 size-6"
                title="ເລີ່ມທົດລອງການນຳທາງ"
              >
                <HelpCircleIcon className="h-4 w-4" />
              </Button>
            </h2>
            <p className="text-muted-foreground">
              ເພີ່ມເມືອງ ຜູກແຂວງ, ຊື່ 3 ພາສາ, ສະຖານະ.
            </p>
          </div>
          <Button
            variant="outline"
            onClick={() => nav({ to: "/app/geo/districts" } as any)}
          >
            <ArrowLeftIcon className="size-4" />
            ກັບຄືນ
          </Button>
        </div>
        <div className="mt-6 rounded-xl border bg-card p-6">
          <DistrictForm
            provinces={provinces}
            onSubmit={async (
              values: DistrictCreateInput | DistrictUpdateInput,
            ) => {
              await createDistrict.mutateAsync(values as DistrictCreateInput);
              nav({ to: "/app/geo/districts" } as any);
            }}
            onCancel={() => nav({ to: "/app/geo/districts" } as any)}
            submitting={createDistrict.isPending}
            onDevFill={isDevMode ? () => {} : undefined}
          />
        </div>
        <DistrictFormTour run={run} onCallback={handleJoyrideCallback} />
      </Main>
    </>
  );
}
